import React from 'react'

import Svg, { ClipPath, Defs, G, Mask, Path, Rect } from 'react-native-svg'

const GoldBar = ({ ...props }) => {
  return (
    <Svg
      width={35}
      height={36}
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_10_387)">
        <Mask
          id="mask0_10_387"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={-1}
          y={0}
          width={35}
          height={35}
        >
          <Path d="M-1 3.8147e-06H34V35H-1V3.8147e-06Z" fill="white" />
        </Mask>
        <G mask="url(#mask0_10_387)">
          <Path
            d="M6.45825 31.6566L28.2173 30.217C31.3212 27.177 33.248 22.9398 33.248 18.252C33.248 9.00226 25.7497 1.50392 16.5 1.50392C7.25033 1.50392 -0.248077 9.00226 -0.248077 18.252C-0.248077 23.7344 2.38642 28.6014 6.45825 31.6566Z"
            fill="#FF6B6B"
          />
          <Path
            d="M31.2205 8.45057L29.7979 8.06913L18.0148 4.91161C16.556 4.52059 15.0569 5.38671 14.6659 6.84549L7.97366 31.822H26.3163C26.9897 31.3339 27.626 30.7976 28.2188 30.2169L32.6335 13.7423L33.1544 11.7995C33.5447 10.3407 32.6793 8.8409 31.2205 8.45057Z"
            fill="#EAB540"
          />
          <Path
            d="M30.9553 9.44113L30.7037 9.37345L17.7496 5.90216C16.8376 5.65812 15.9005 6.19884 15.6564 7.11076L9.03494 31.822H26.3178L26.3178 31.8223C26.4917 31.6964 26.6632 31.5674 26.8318 31.4351L32.0401 11.9957L32.1639 11.5336C32.4079 10.6224 31.8672 9.68517 30.9553 9.44113Z"
            fill="#FECA57"
          />
          <Path
            d="M13.2811 31.822L19.618 8.17221C19.8623 7.26057 20.7994 6.71951 21.711 6.96376L17.7493 5.90227C16.8376 5.65796 15.9005 6.19895 15.6562 7.11066L9.03482 31.822H13.2811Z"
            fill="#FFB332"
          />
          <Path
            d="M20.6368 21.5378C17.5371 20.7072 15.6976 17.5212 16.5281 14.4214C17.3587 11.3216 20.5449 9.48216 23.6446 10.3127C26.7442 11.1433 28.5839 14.3294 27.7533 17.4291C26.9227 20.5289 23.7366 22.3684 20.6368 21.5378Z"
            fill="#FFECBC"
          />
          <Path
            d="M20.9022 20.5474C18.3537 19.8645 16.8357 17.2354 17.5186 14.6868C18.2015 12.1381 20.8306 10.6203 23.3792 11.3032C25.9278 11.986 27.4457 14.6151 26.7628 17.1637C26.0799 19.7124 23.4508 21.2303 20.9022 20.5474Z"
            fill="#EAB540"
          />
          <Path
            d="M25.4422 16.8099C25.6433 16.0593 25.3989 15.2927 24.8719 14.7914C24.6828 14.6115 24.5495 14.3807 24.4883 14.1269C24.3177 13.4199 23.7759 12.8249 23.0253 12.6238C22.2748 12.4227 21.5081 12.6671 21.0068 13.194C20.8268 13.3833 20.5961 13.5164 20.3423 13.5777C19.6353 13.7483 19.0403 14.29 18.8392 15.0406C18.6381 15.7912 18.8825 16.5579 19.4095 17.0591C19.5987 17.2391 19.7319 17.4698 19.7931 17.7237C19.9637 18.4306 20.5055 19.0256 21.2561 19.2268C22.0067 19.4279 22.7733 19.1835 23.2746 18.6565C23.4545 18.4673 23.6853 18.3341 23.9391 18.2729C24.6461 18.1022 25.2412 17.5605 25.4422 16.8099Z"
            fill="#FFC839"
          />
          <Path
            d="M21.7868 17.2459C21.0587 17.0508 20.625 16.2996 20.8201 15.5714C21.0153 14.8432 21.7664 14.4096 22.4946 14.6047C23.2227 14.7998 23.6565 15.551 23.4613 16.2791C23.2662 17.0073 22.515 17.441 21.7868 17.2459Z"
            fill="#FFECBC"
          />
          <Path
            d="M26.318 31.8219C23.5597 33.8214 20.1677 34.9999 16.5003 34.9999C12.733 34.9999 9.25621 33.7565 6.4582 31.6565L1.09957 11.66L-0.154138 6.98148C-0.54447 5.52269 0.32096 4.02289 1.77975 3.63256L14.9854 0.0935898C16.2904 -0.255726 17.6275 0.400528 18.1751 1.58656C18.2392 1.7267 18.2933 1.87367 18.3343 2.02748L26.318 31.8219Z"
            fill="#EAB540"
          />
          <Path
            d="M25.4188 32.4297C22.8362 34.058 19.7785 35 16.5 35C13.2947 35 10.2998 34.0997 7.75483 32.5377L1.78357 10.2505L0.836178 6.71562C0.592067 5.80439 1.13279 4.86719 2.0447 4.62314L15.2504 1.08418C15.8527 0.922852 16.4658 1.104 16.8835 1.50869C17.0981 1.7165 17.2608 1.9831 17.3435 2.29277L25.4188 32.4297Z"
            fill="#FECA57"
          />
          <Path
            d="M12.5345 34.5276C10.8235 34.1127 9.21489 33.4339 7.7548 32.5377L1.78354 10.2505L0.83615 6.71564C0.592107 5.80441 1.13283 4.8672 2.04474 4.62316L6.00685 3.56154C5.09494 3.80558 4.55353 4.74279 4.79826 5.6547L4.92951 6.14347L12.5345 34.5276Z"
            fill="#FFC839"
          />
          <Path
            d="M12.3632 16.7199C9.26344 17.5504 6.07735 15.711 5.24672 12.6112C4.41615 9.51145 6.2557 6.32536 9.35539 5.49479C12.4551 4.66423 15.6413 6.50371 16.4719 9.60346C17.3024 12.7032 15.463 15.8893 12.3632 16.7199Z"
            fill="#FFC839"
          />
          <Path
            d="M12.0978 15.7294C9.5492 16.4123 6.9201 14.8945 6.23719 12.3458C5.55428 9.79721 7.0722 7.16811 9.62084 6.48527C12.1694 5.80236 14.7985 7.32021 15.4814 9.86885C16.1643 12.4175 14.6463 15.0465 12.0978 15.7294Z"
            fill="#EAB540"
          />
          <Path
            d="M9.62081 6.48524C7.07224 7.16815 5.55432 9.79718 6.23716 12.3458C6.92007 14.8945 9.54917 16.4123 12.0977 15.7294C11.7331 15.8272 11.3583 15.6107 11.2605 15.2461C11.1629 14.8814 11.3793 14.5065 11.744 14.4088L9.97471 7.8058C9.61001 7.90356 9.23513 7.68713 9.13744 7.3225C9.03969 6.95781 9.25611 6.58292 9.62081 6.48524Z"
            fill="#EAB540"
          />
          <Path
            d="M14.1608 10.2227C13.9597 9.47211 13.3646 8.93036 12.6577 8.75974C12.4039 8.69849 12.1731 8.56526 11.9932 8.37611C11.4919 7.84912 10.7252 7.60474 9.97471 7.80585C9.22405 8.00696 8.68231 8.60196 8.51168 9.30894C8.4505 9.56276 8.31727 9.79354 8.12805 9.97346C7.60107 10.4747 7.35668 11.2414 7.55779 11.992C7.75891 12.7426 8.35391 13.2843 9.06088 13.4549C9.3147 13.5162 9.54548 13.6493 9.7254 13.8386C10.2267 14.3655 10.9933 14.6099 11.744 14.4088C12.4945 14.2077 13.0363 13.6127 13.2069 12.9057C13.2681 12.6519 13.4014 12.4211 13.5905 12.2412C14.1175 11.7399 14.3619 10.9733 14.1608 10.2227Z"
            fill="#FECA57"
          />
          <Path
            d="M11.2132 12.4279C10.485 12.623 9.7338 12.1894 9.5387 11.4612C9.34354 10.733 9.77728 9.98183 10.5054 9.78674C11.2336 9.59164 11.9847 10.0253 12.1799 10.7535C12.375 11.4817 11.9413 12.2328 11.2132 12.4279Z"
            fill="#FFECBC"
          />
          <Path
            d="M10.8593 11.1073C10.7287 10.6198 10.8808 10.1229 11.2137 9.78855C10.9889 9.72771 10.7461 9.72224 10.5054 9.78678C9.77731 9.98187 9.34357 10.733 9.53873 11.4612C9.73383 12.1894 10.485 12.6231 11.2132 12.4279C11.4538 12.3634 11.6613 12.2374 11.8256 12.0723C11.3703 11.9491 10.9899 11.5949 10.8593 11.1073Z"
            fill="#FFECBC"
          />
          <Path
            d="M16.8748 33.5576C16.3287 33.7039 15.7653 33.3786 15.619 32.8325C15.4726 32.2864 15.7979 31.723 16.344 31.5767C16.8902 31.4303 17.4536 31.7556 17.5999 32.3017C17.7462 32.8479 17.4209 33.4112 16.8748 33.5576Z"
            fill="#FFC839"
          />
          <Path
            d="M17.257 21.778L10.654 23.5473C10.107 23.6938 9.5448 23.3692 9.39817 22.8222C9.2516 22.2752 9.57624 21.7129 10.1233 21.5664L16.7262 19.7971C17.2732 19.6505 17.8355 19.9752 17.9821 20.5222C18.1287 21.0692 17.804 21.6314 17.257 21.778Z"
            fill="#FFECBC"
          />
          <Path
            d="M12.0394 22.1144C11.8928 21.5674 12.2174 21.0052 12.7644 20.8586L10.1233 21.5663C9.57624 21.7129 9.2516 22.2751 9.39817 22.8222C9.5448 23.3692 10.107 23.6938 10.654 23.5472L13.2952 22.8395C12.7482 22.9861 12.186 22.6614 12.0394 22.1144Z"
            fill="white"
          />
          <Path
            d="M19.6392 25.3859L10.395 27.8629C9.84802 28.0094 9.28569 27.6849 9.13913 27.1379C8.99257 26.5908 9.31721 26.0286 9.86422 25.882L19.1084 23.405C19.6554 23.2585 20.2177 23.583 20.3642 24.13C20.5108 24.6771 20.1862 25.2393 19.6392 25.3859Z"
            fill="#FFECBC"
          />
          <Path
            d="M11.7803 26.4301C11.6337 25.8831 11.9583 25.3208 12.5054 25.1743L9.86422 25.882C9.31721 26.0286 8.99257 26.5908 9.13913 27.1378C9.28569 27.6848 9.84795 28.0095 10.395 27.8629L13.0362 27.1552C12.4892 27.3018 11.927 26.9771 11.7803 26.4301Z"
            fill="#EAB540"
          />
          <Path
            d="M20.4353 28.3573L11.1912 30.8343C10.6442 30.9808 10.0819 30.6562 9.93527 30.1092C9.78871 29.5622 10.1134 28.9999 10.6604 28.8533L19.9045 26.3763C20.4515 26.2298 21.0139 26.5544 21.1604 27.1014C21.307 27.6484 20.9824 28.2107 20.4353 28.3573Z"
            fill="#FFECBC"
          />
          <Path
            d="M12.5765 29.4015C12.4299 28.8545 12.7545 28.2922 13.3015 28.1457L10.6604 28.8533C10.1134 28.9999 9.78871 29.5622 9.93527 30.1092C10.0819 30.6562 10.6441 30.9809 11.1911 30.8342L13.8323 30.1265C13.2853 30.2731 12.7231 29.9485 12.5765 29.4015Z"
            fill="#EAB540"
          />
          <Path
            d="M27.5035 19.1825C27.124 18.9757 26.8018 18.6776 26.5663 18.3152C26.5001 18.2134 26.3861 18.153 26.2648 18.1577C26.1435 18.1624 26.0346 18.2315 25.9764 18.3381C25.7697 18.7176 25.4715 19.0398 25.1092 19.2753C25.0073 19.3416 24.947 19.4554 24.9516 19.5769C24.9563 19.6982 25.0254 19.8071 25.1321 19.8652C25.5115 20.072 25.8337 20.3701 26.0693 20.7325C26.1355 20.8343 26.2494 20.8947 26.3707 20.89C26.4921 20.8853 26.601 20.8162 26.6591 20.7096C26.8659 20.33 27.164 20.0079 27.5264 19.7724C27.6281 19.7062 27.6886 19.5922 27.6839 19.4709C27.6792 19.3495 27.6102 19.2406 27.5035 19.1825Z"
            fill="white"
          />
          <Path
            d="M10.4061 24.7693C9.97391 24.7681 9.54872 24.6593 9.16905 24.4528C9.06241 24.3948 8.93335 24.3958 8.82896 24.4578H8.82889C8.72444 24.5196 8.66148 24.6323 8.66121 24.7537C8.66005 25.1859 8.55122 25.6111 8.34477 25.9908C8.28667 26.0974 8.28783 26.2264 8.34969 26.3309C8.41156 26.4353 8.52422 26.4983 8.64562 26.4986C9.07786 26.4998 9.50305 26.6086 9.88272 26.8151C9.98936 26.8731 10.1184 26.872 10.2228 26.8101C10.3273 26.7482 10.3902 26.6356 10.3905 26.5142C10.3917 26.082 10.5006 25.6568 10.707 25.2771C10.7651 25.1704 10.7639 25.0414 10.7021 24.937C10.6402 24.8325 10.5276 24.7696 10.4061 24.7693Z"
            fill="white"
          />
          <Path
            d="M5.65209 19.4969C5.14186 19.0969 4.73915 18.5761 4.48041 17.9817C4.40775 17.8147 4.25414 17.697 4.0734 17.6739C3.8928 17.6508 3.71445 17.726 3.60213 17.8694C3.20216 18.3796 2.68133 18.7824 2.08695 19.0411C1.91988 19.1138 1.8023 19.2674 1.77919 19.4481C1.75609 19.6287 1.83128 19.807 1.97463 19.9194C2.48487 20.3194 2.88764 20.8401 3.14631 21.4346C3.21898 21.6016 3.37258 21.7192 3.55332 21.7423C3.734 21.7654 3.91228 21.6902 4.02459 21.5468C4.42456 21.0366 4.94539 20.6339 5.53978 20.3752C5.70685 20.3025 5.8245 20.1489 5.8476 19.9682C5.87071 19.7875 5.79551 19.6093 5.65209 19.4969Z"
            fill="white"
          />
          <Path
            d="M20.7557 5.5441C20.3508 5.0377 20.0784 4.43839 19.963 3.80046C19.9307 3.62115 19.8082 3.47138 19.6376 3.40746C19.467 3.34348 19.2762 3.37581 19.134 3.48949C18.6276 3.89432 18.0282 4.16673 17.3903 4.28212C17.211 4.31452 17.0613 4.43702 16.9973 4.60758C16.9333 4.77814 16.9657 4.96886 17.0794 5.11118C17.4842 5.61759 17.7566 6.2169 17.872 6.85483C17.9044 7.03406 18.0269 7.18391 18.1974 7.24782C18.368 7.31181 18.5588 7.27947 18.701 7.16579C19.2075 6.76097 19.8068 6.48856 20.4448 6.37317C20.624 6.34076 20.7738 6.21826 20.8377 6.04771C20.9017 5.87715 20.8694 5.68643 20.7557 5.5441Z"
            fill="white"
          />
        </G>
      </G>
      <Defs>
        <ClipPath id="clip0_10_387">
          <Rect width={35} height={35} fill="white" transform="translate(-1)" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default GoldBar
